<script setup>
import Logo from "@/Components/AdminLayout/logo/LogoDark.vue";
import { useTheme } from 'vuetify'
const theme = useTheme()
const props = defineProps({
    fromDialog: {
        type: Boolean,
        default: false,
    },
});
</script>
<template>

    <div class="min-h-full bg-land-backgr ound mt-20">
        <v-container class="h-full">
            <v-row class="min-h-[99v h] h-full">

                <v-col cols="12" md="6" class="min-h-full md:block" v-if="!fromDialog">
                    <div class="flex flex-col items-center justify-center h-full text-center bg-top bg-no-repeat rounded-lg bg-cov er bg-primary "
                        style="background-image: url('/assets/patterns/pattern.png')">
                        <div class="mt-5 text-center">
                            <h2 class="font-bold h2">
                                {{ __t(route().current()) }}


                            </h2>
                            <h3 class="mt-5 mb-5">
                                {{ $page.props.setting.site_title[$page.props.locale] }}
                            </h3>
                        </div>
                    </div>

                </v-col>
                <v-col class="flex items-center justify-center overflow-scroll m- min-h-fu ll">
                    <div class="flex flex-col justify-center w-full h-full my-auto md:p-1 6">
                        <v-card class="my-auto p-9 h- max ">
                            <slot />
                        </v-card>
                    </div>
                </v-col>
            </v-row>
        </v-container>


    </div>
</template>
